// import { jsPDF } from "jspdf";
// import { addHeaderAndFooter } from "./addHeaderAndFooter";
import { addPics } from "./addPics";
import { addPage } from "./addPage";
import { setFont } from "./setFont";

import { addFormattedText } from "./addFormattedText";
import obsDoc from "./obsDoc";

export async function exportChecklistRows(doc, rows, cursorY) {
  const pageHeight = doc.internal.pageSize.height - 1; // Get page height minus some
  for (let i = 0; i < rows.length; i++) {
    //addPage if at bottom of page
    if (cursorY + 1 > pageHeight) {
      cursorY = await addPage(doc, cursorY);
    }
    console.log("The number is " + i);
    setFont(doc, true);
    // cursorY = await addFormattedText(doc, cursorY, );

    doc.text(rows[i]["Row Text"], obsDoc.xPosition, cursorY);

    cursorY += obsDoc.lineSpacing;
    setFont(doc, false);
    if (
      typeof rows[i]["value"] !== "object" &&
      rows[i]["Row Type"] !== "Header" &&
      rows[i]["Row Type"] !== "Information Row" &&
      rows[i]["Row Type"] !== "File" &&
      rows[i]["Row Type"] !== "Signature"
    ) {
      cursorY = await addFormattedText(doc, cursorY, rows[i]["value"]);
    } else if (rows[i]["Row Type"] === "Signature") {
      console.log(rows[i]["Row Type"]);
      cursorY = await addPics(
        doc,
        rows[i].value
          ? [
              {
                name: rows[i].value,
                file: rows[i].value,
                url: rows[i].value,
                comment: "",
              },
            ]
          : [],
        cursorY,
      );
    } else if (rows[i]["Row Type"] === "File") {
      doc.textWithLink(rows[i].value.name, obsDoc.xPosition, cursorY, {
        url: rows[i].value.url,
      });

      cursorY += obsDoc.lineSpacing;
    } else if (
      rows[i]["Row Type"] !== "Header" ||
      rows[i]["Row Type"] !== "Information Row"
    ) {
      cursorY += obsDoc.lineSpacing;
    }
  }

  cursorY += obsDoc.lineSpacing * 2;

  return cursorY;
}
